var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartIsFavoritesAndIsBrownSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01934 1.33742C10.6163 -0.261278 13.2056 -0.261278 14.8025 1.33742C16.3967 2.93337 16.3991 5.51918 14.8098 7.11815L8.74265 13.7005C8.64798 13.8032 8.51467 13.8616 8.375 13.8616C8.23533 13.8616 8.10202 13.8032 8.00735 13.7005L1.94015 7.11815C0.35085 5.51917 0.353287 2.93337 1.94746 1.33742C3.54438 -0.261277 6.13373 -0.261276 7.73065 1.33742L8.375 1.98249L9.01934 1.33742Z",
    fill: "#D6A191"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIsFavoritesAndIsBrownSvg);
export default __webpack_public_path__ + "static/media/heartIsFavoritesAndIsBrownSvg.49663aeb7ce67574d5c4bad5355b52c7.svg";
export { ForwardRef as ReactComponent };